export const REQUESTED = 'COACH_DASHBOARD_REQUESTED';
export const FAILED = 'COACH_DASHBOARD_FORGOT_FAILED';
export const SUCCESSFUL = 'COACH_DASHBOARD_FORGOT_SUCCESSFUL';
export const REQUEST_REQUESTED = 'GET_ALL_REQUEST_REQUESTED';
export const REQUEST_FAILED = 'GET_ALL_REQUEST_FAILED';
export const REQUEST_SUCCESSFUL = 'GET_ALL_REQUEST_SUCCESSFUL';
export const ADD_CONVERSATION_REQUESTED = 'ADD_CONVERSATION_REQUESTED';
export const ADD_CONVERSATION_FAILED = 'ADD_CONVERSATION_FAILED';
export const ADD_CONVERSATION_SUCCESSFUL = 'ADD_CONVERSATION_SUCCESSFUL';
export const COACH_PROFILE_REQUESTED = 'COACH_PROFILE_REQUESTED';
export const COACH_PROFILE_SUCCESSFUL = 'COACH_PROFILE_SUCCESSFUL';
export const COACH_PROFILE_FAILED = 'COACH_PROFILE_FAILED';
export const DIVISION_STUDENT_REQUESTED = 'DIVISION_STUDENT_REQUESTED';
export const DIVISION_STUDENT_FAILED = 'DIVISION_STUDENT_FAILED';
export const DIVISION_STUDENT_SUCCESSFUL = 'FILTER_DIVISION_STUDENT_SUCCESSFUL';
export const FILTER_DIVISION_STUDENT_REQUESTED = 'FILTER_DIVISION_STUDENT_REQUESTED';
export const FILTER_DIVISION_STUDENT_FAILED = 'FILTER_DIVISION_STUDENT_FAILED';
export const FILTER_DIVISION_STUDENT_SUCCESSFUL = 'FILTER_DIVISION_STUDENT_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/containers/DashBoardCoach/actionTypes.js